import { Icon, Select } from '@anytag/shared-atoms';
import { SelectOption } from '@anytag/shared-types';
import { InfluencerAvatar } from '@anytag/shared-molecules';
import { AnalyticsComparableAccountType } from './types';
import { supportedCompareAccountColors } from './utils';

type AccountId = AnalyticsComparableAccountType['id'];

export interface AnalyticsCompareOverviewAccountsProps {
  visibleAccountIds?: AccountId[];
  onSetVisibleAccountIds?: (ids: AccountId[]) => void;
  comparableAccounts: AnalyticsComparableAccountType[];
}
export const AnalyticsCompareOverviewAccounts = ({
  comparableAccounts,
  visibleAccountIds = [],
  onSetVisibleAccountIds
}: AnalyticsCompareOverviewAccountsProps) => {
  const remainingAccounts = comparableAccounts.filter((account) => !visibleAccountIds.includes(account.id));

  return visibleAccountIds.length ? (
    <div className="flex flex-wrap items-center">
      {visibleAccountIds.map((id, index) => (
        <Select
          clearable={false}
          value={String(id)}
          key={`account-${index}-${id}`}
          className="max-w-1/5 flex-1/5"
          options={buildOptions(
            comparableAccounts.find((acc) => acc.id === id),
            remainingAccounts,
            index
          )}
          onChange={(id) => {
            const newVisibleAccountIds = [...visibleAccountIds];
            newVisibleAccountIds[index] = Number(id);
            onSetVisibleAccountIds?.(newVisibleAccountIds);
          }}
        />
      ))}
    </div>
  ) : null;
};

const buildOptions = (
  account: AnalyticsComparableAccountType | undefined,
  allAccounts: AnalyticsComparableAccountType[],
  idx: number
) =>
  [
    ...(account ? prepareDropdownOptions([account], idx) : []),
    ...prepareDropdownOptions(allAccounts, idx),
    // Hidden option
    {
      value: '-1',
      label: 'Hidden',
      prefixIcon: (
        <div className="mr-1 flex size-5 items-center justify-center rounded-full bg-black">
          <Icon icon="eye-mask" size="16px" variant="white" />
        </div>
      )
    }
  ] satisfies SelectOption<string>[];

const prepareDropdownOptions = (accounts: AnalyticsComparableAccountType[], index: number) =>
  accounts.map<SelectOption<string>>((acc) => ({
    ...acc,
    label: acc.username,
    value: String(acc.id),
    prefixIcon: (
      <div className="flex items-center gap-2">
        <div className="size-3.5 flex-none" style={{ backgroundColor: supportedCompareAccountColors[index] }} />
        <div className="h-5 w-px bg-black-20" />
        <InfluencerAvatar size="20px" className="rounded-full" src={acc.avatarUrl} />
      </div>
    )
  }));
